import { getStore } from '@/store';
import * as TYPES from './types';

export default {
    [TYPES.PAGE_CHANGE_MUTATION](payload) {
        if (payload.page) {
            let trackStore = getStore.call(this, 'track');
            this.page = payload.page;
            trackStore.trackUpdatePage(payload.page);
        }
        if (payload.pageSize) {
            this.pageSize = payload.pageSize;
        }
    },
    [TYPES.SORT_UPDATE_MUTATION](payload) {
        let trackStore = getStore.call(this, 'track');
        this.sort = payload;
        trackStore.trackUpdateSort(payload);
    },
    [TYPES.MAP_DRAWING_CHANGE_MUTATION](payload) {
        this.drawing = payload;
    },
    [TYPES.UPDATE_LOADING_MUTATION](payload) {
        this.loading = payload;
    },
    [TYPES.UPDATE_IS_MAP_LOADING](payload) {
        this.isMapLoading = payload;
    },
    [TYPES.UPDATE_SEARCH_PARAMS](payload) {
        this.$patch(state => {
            state.searchParams = { ...payload };
        })
    },
    [TYPES.MAP_RESULT_UPDATE_MUTATION](payload) {
        this.$patch(state => {
            if (
                state.layout === 'map' &&
                !state.mapType &&
                !payload.noMapSearch
            ) {
                state.result.counts = payload.counts;
                state.result.searchType = payload.searchType;
            }
            state.mapResult = {
                house: payload.house,
                aggregation: payload.aggregation
            };
        });
    },
    [TYPES.SORT_UPDATE_MUTATION](payload) {
        this.sort = payload;
    },
    [TYPES.GRID_OR_LIST_TYPE_MUTATION](payload) {
        this.$patch(state => {
            state.gridOrListType = payload;
            if (state.layout === 'map') {
                state.mode = 'map'
            } else if (state.layout === 'normal') {
                state.mode = state.gridOrListType;
            } else if (state.layout === 'mixed') {
                state.mode = `map+${state.gridOrListType}`
            }
        });
    },
    [TYPES.SHOW_INSIGHT_UPDATE_MUTATION]({ isShow, lastLayout = '', isMobile }) {
        this.$patch(state => {
            state.showInsight = isShow;
            if (isShow) {
                state.lastLayout = lastLayout;
            } else if (state.lastLayout) {
                this[TYPES.LAYOUT_UPDATE_MUTATION]({
                    layout: state.lastLayout,
                    isMobile
                });
                state.lastLayout = '';
            }
        });
    },
    [TYPES.ACTIVE_HOUSE_MARKER_MUTATION](payload) {
        this.$patch(state => {
            let selectedHouse = state.selectedHouse;
            let id = payload.id;
            selectedHouse[id] = payload.active;
            if (payload.active === 1) {
                let lid = state.lastSelectedHouse;
                if (lid && lid !== id && selectedHouse[lid] === 1) {
                    selectedHouse[lid] = 0;
                }
                state.lastSelectedHouse = id;
            }
            state.selectedHouse = Object.assign({}, selectedHouse);
        });
    },
    [TYPES.REMOVE_ALL_FILTERS]() {
        this.$patch(state => {
            state.keywords = [];
            state.conditions = {};
            state.conditionsArr = [];
            state.mapCondition = Object.assign({}, state.mapCondition, {
                mapPath: null,
                mapSearch: false,
                mapRadius: null
            });
        });
    },
    [TYPES.SET_SORT_CONFIGS](payload) {
        this.listingSortOptions = payload;
    },
    [TYPES.SET_MAP_INITED](payload) {
        this.mapInited = payload;
    },
    [TYPES.REMOVE_OUTLINE_REGION]() {
        this.mapCondition = Object.assign({}, this.mapCondition, {
            mapPath: null,
            mapRadius: null,
            mapSearch: false
        });
    },
    [TYPES.AVERAGE_DATA_MUTATION](payload) {
        this.averageData = payload;
    },
    [TYPES.SET_CENTER_POINT](payload) {
        this.centerPoint = payload;
    },
    [TYPES.SET_ZOOM](payload) {
        this.zoom = payload;
    },
    [TYPES.PROPERTY_GATHERING_AMOUNT](payload) {
        this.property_gathering_amount = payload;
    },
    [TYPES.SET_BREAD_CRUMBS](payload) {
        this.breadCrumbs = payload;
    },
    async [TYPES.MARKET_REPORT_DISPATCH](payload) {
        if (this.platform.isBot) {
            return;
        }
        const ret = await this.axiosIns({
            url: '/api-site/snapshot/market-report',
            cancelKey: '/api-site/snapshot/market-report' + this.$id,
            method: 'get',
            params: { ...payload }
        });
        this.marketReport = ret.data?.marketReport || ret.marketReport;
    }
};
